'use strict';

export class ProfileFavorites {
	constructor(component_key) {
		this.id = component_key;
		this.data = yalwa.v.components[component_key];
		this.$root = jQuery(`.js-${this.id}`);
	}

	init() {
		// Potential for AJAX pagination or "unfavorite" actions here
		console.log('ProfileFavorites initialized:', this.id);
	}
}

Object.keys(yalwa.v.components).forEach(key => {
	if (key.startsWith('profilefavorites_')) {
		new ProfileFavorites(key).init();
	}
});